/* eslint no-console:0 */

const log = {
  info: (...args) => console.info(args.join(" ")),
  warn: (...args) => console.warn(args.join(" ")),
  error: (...args) => console.error(args.join(" ")),
}

export default log
